






























































































import { Component, Vue, Watch } from 'vue-property-decorator'
import { Route } from 'vue-router'
import { Dictionary } from 'vue-router/types/router'
import { Form as ElForm, Input } from 'element-ui'
import { UserModule } from '@/store/modules/user'
// 用户信息
import { setToken, setUser, setApply, getApply, removeApply } from '@/utils/cookies'
// 随机码
import { randomNum } from '@/utils'
// api接口
import { getAllList } from '@/pages/adhibition/api/index'
import { getCode, loginInfo } from '@/pages/base/api/api'
@Component({
  name: 'Logins'
})
export default class extends Vue {
  // 密码验证
  private validatePassword = (rule: any, value: string, callback: Function) => {
    if (value.length < 6) {
      callback(new Error('密码不能少于6位'))
    } else {
      callback()
    }
  }
  // 验证码验证
  private validateVerificationCode = (
    rule: any,
    value: string,
    callback: Function
  ) => {
    if (value.length < 4) {
      callback(new Error('验证码不能少于4位'))
    } else {
      callback()
    }
  }
  // 验证
  private loginRules = {
    account: [{ required: true, message: '请输入账号', trigger: 'blur' }],
    password: [{ validator: this.validatePassword, trigger: 'blur' }],
    code: [{ validator: this.validateVerificationCode, trigger: 'blur' }]
  }
  private imageCode = ''
  private randomId = randomNum(24, 16)
  private loginForm = {
    account: '',
    code: '',
    key: '',
    password: ''
  }
  private passwordType = 'password'
  private loading = false
  private showDialog = false
  private redirect?: string
  private isPostBack = true

  private otherQuery: Dictionary<string> = {}
  @Watch('$route', { immediate: true })
  private onRouteChange(route: Route) {
    const query = route.query as Dictionary<string>
    if (query) {
      this.redirect = query.redirect
      this.otherQuery = this.getOtherQuery(query)
    }
  }
  // 挂载结束
  mounted() {
    if (this.loginForm.account === '') {
      (this.$refs.account as Input).focus()
    } else if (this.loginForm.password === '') {
      (this.$refs.password as Input).focus()
    }
    // if (this.isPostBack) {
    this.getCode(this.randomId)
    // }
  }
  // 获取验证码图片
  private async getCode(val: string) {
    this.loginForm.code = ''
    const response = await getCode(this.randomId)
    const res = response.data
    const data =
      'data:image/png;base64,' +
      btoa(
        new Uint8Array(res).reduce(
          (data, byte) => data + String.fromCharCode(byte),
          ''
        )
      )
    this.imageCode = data
  }
  // 显示隐藏密码
  private showPwd() {
    if (this.passwordType === 'password') {
      this.passwordType = ''
    } else {
      this.passwordType = 'password'
    }
    this.$nextTick(() => {
      (this.$refs.password as Input).focus()
    })
  }
  // 登录
  private handleLogin() {
    (this.$refs.loginForm as ElForm).validate(async(valid: boolean) => {
      this.loginForm.key = this.randomId
      let params = {} as any
      if (valid) {
        this.loading = true
        const res = await UserModule.Login(this.loginForm)
        if (res.isSuccess) {
          await UserModule.GetUserInfo()
          setUser(res.data.user)
          setToken(res.data.token.token)
          const { data } = await getAllList({})
          // 默认赋值应用
          if (res.data.user.id >= 10) {
            // 非管理员
            setApply(JSON.stringify(data.data[0]))
          } else {
            // 管理员
            setApply(JSON.stringify({ 'id': '1', 'createTime': null, 'createUser': null, 'updateTime': null, 'updateUser': null, 'name': '应用选择', 'abbreviation': '权限管家', 'status': null, 'describe': null }))
            this.$store.commit('updatedTheme', '')
            this.$store.commit('updatedThemeColor', '#409EFF')
          }
          this.$router.push({
            path: this.redirect || '/',
            query: this.otherQuery
          }, () => {})
          params.description = '登录成功！'
          this.loading = false
        } else {
          // this.$message.error(res.msg || '操作失败')
          this.loading = false
          this.getCode(this.randomId)
          params.description = res.msg
        }
        params.name = this.loginForm.account
        // 记录日志
        const { data } = await loginInfo(params)
      } else {
        return false
      }
    })
  }

  private getOtherQuery(query: Dictionary<string>) {
    return Object.keys(query).reduce((acc, cur) => {
      if (cur !== 'redirect') {
        acc[cur] = query[cur]
      }
      return acc
    }, {} as Dictionary<string>)
  }
}
